"use strict";

import axios from "axios";
import { getToken } from "@/scripts/keycloak.js";
import { reportApiError, refreshOrLogin } from "@/scripts/apiErrors.js";

axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT + "/v1";

axios.interceptors.request.use(
  (request) => {
    request.headers.Authorization = "Bearer " + getToken();
    window.logOrange((request.method + " REQUEST").toUpperCase(), request.url, request);
    return request;
  },
  (error) => {
    window.logRed(error.message, error);
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    window.logGreen((response.config.method + " RESPONSE").toUpperCase(), response.config.url, response);
    return response;
  },
  async (error) => {
    const status = error.response && error.response.status;
    const config = error.config || {};
    window.logRed(error.message, config.url);

    // One silent retry on 401: the token has usually just expired between requests.
    if (status === 401 && !config.__retried) {
      config.__retried = true;
      if (await refreshOrLogin()) {
        return axios(config);
      }
      return Promise.reject(error);
    }

    reportApiError(status, config.url);
    return Promise.reject(error);
  }
);

export default axios;
